import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bot, X, Sparkles } from 'lucide-react';

export default function FloatingAIBadge() {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(true);
  const location = useLocation();

  // Don't show on AI Advisor page or login/register pages
  const hiddenPaths = ['/ai-advisor', '/login', '/register'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));

  // Animate the badge periodically
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 1000);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  if (!isVisible || shouldHide) return null;

  return (
    <div className="fixed bottom-20 right-4 z-50 md:hidden" data-testid="floating-ai-badge">
      {/* Close button */}
      <button
        onClick={() => setIsVisible(false)}
        className="absolute -top-2 -right-2 w-6 h-6 bg-background border border-border rounded-full flex items-center justify-center shadow-md z-10"
        aria-label="Dismiss"
      >
        <X className="w-3 h-3 text-muted-foreground" />
      </button>

      {/* Main badge */}
      <Link to="/ai-advisor">
        <div 
          className={`relative flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-gold to-amber-500 text-black rounded-full shadow-lg ${
            isAnimating ? 'animate-bounce' : ''
          }`}
        >
          {/* Pulsing ring effect */}
          <span className="absolute inset-0 rounded-full bg-gold/30 animate-ping opacity-75" />
          
          {/* Bot icon with sparkle */}
          <div className="relative">
            <Bot className="w-6 h-6" />
            <Sparkles className="absolute -top-1 -right-1 w-3 h-3 text-white animate-pulse" />
          </div>
          
          {/* Text */}
          <div className="relative">
            <p className="font-semibold text-sm">AI Advisor</p>
            <p className="text-xs opacity-80">Ask me anything!</p>
          </div>
        </div>
      </Link>

      {/* Floating particles effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
        <span className="absolute w-2 h-2 bg-gold rounded-full animate-float-1 opacity-60" style={{ top: '-20px', left: '-10px' }} />
        <span className="absolute w-1.5 h-1.5 bg-amber-400 rounded-full animate-float-2 opacity-60" style={{ top: '-15px', left: '20px' }} />
        <span className="absolute w-1 h-1 bg-yellow-300 rounded-full animate-float-3 opacity-60" style={{ top: '-25px', left: '5px' }} />
      </div>
    </div>
  );
}
